export default __webpack_public_path__ + "static/media/spinnies.842f38f0.gif";